/** Hex line colors aligned with shipment status (Tailwind-like hues). */
export const SHIPMENT_STATUS_LINE_COLOR_HEX: Record<string, string> = {
  'In Progress': '#3b82f6',
  Completed: '#22c55e',
  'Not Started': '#e5e7eb',
  'Running Late': '#fb923c',
  'Completed Late': '#fb923c',
};

export function lineColorHexForShipmentStatus(
  status: string | undefined,
): string {
  if (!status) return '#64748b';
  return SHIPMENT_STATUS_LINE_COLOR_HEX[status] ?? '#64748b';
}

/**
 * Distinct hues for additional devices in a multi-device shipment (ENG-2580 convoy).
 * Index 0 uses the shipment status color; further devices cycle this palette.
 */
export const SHIPMENT_DEVICE_TRACK_COLOR_HEX: string[] = [
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
  '#f59e0b',
  '#0ea5e9',
  '#84cc16',
];

/**
 * Track line color for the device at `deviceIndex` within a shipment's device list.
 * Index 0 uses the shipment status color; further devices cycle a distinct palette.
 */
export function lineColorHexForShipmentDevice(
  status: string | undefined,
  deviceIndex: number,
): string {
  if (deviceIndex <= 0) {
    return lineColorHexForShipmentStatus(status);
  }
  const palette = SHIPMENT_DEVICE_TRACK_COLOR_HEX;
  return palette[(deviceIndex - 1) % palette.length]!;
}
